export class Memberprofile {

       PROFILE_ID: string;
       MEMBER_TMC: string;
       MEMBER_NAME: string;
       MEMBER_DEPARTMENT: string;
       MEMBER_DESIGNATION: string;
       MEMBER_SBU: string;
       MEMBER_SBU_CODE: string;
       MEMBER_SUB_BU: string;
       MEMBER_SBU_HEAD: string;
       MEMBER_REPORTING_MANAGER: string;
       MEMBER_REPORTING_EMAIL: string;
       MEMBER_BRANCH_NAME: string;
       MEMBER_EMAIL: string;
       DATE_OF_JOINING: string;
       MEMBER_EXP_TYPE: string = 'Fresher';
       MEMBER_EXPERIENCE: string;
       MEMBER_DEGREE: string;
       MEMBER_INTEREST: string;
       Member_Hobbies: string;
       MEMBER_HOME: string;
       OTHER_EMAIL: string;
       MAIL_TO: string;
       MAIL_CC: string;
       MAIL_BCC: string;
       BUHR_ASSIGNED_TMC: string;
       BUHR_ASSIGNED_EMAIL: string;
       MEMBER_PROF_LOCATION: string;
       MEMBER_PROF_DOMAIN: string;
       STATUS: string;
       SUBMISSION_DATE: string;
       PROFILE_UPDATED: string;
       REQUEST_SENT: string;
       MAIL_SENT: string;
       HR_REMARKS: string = '';
       MAIL_SUBMISSION_BY: string;
       MAIL_SUBMISSION_DATE: string;
       CREATED_BY: string;
       CREATED_ON: string;
       MODIFIED_BY: string;
       MODIFIED_ON: string;
       ACTIVE: string;
       MEMBER_GENDER: string;
       Mobile_Phone_No: string = '';
       Member_Functional_Area: string;
       ProfileFileName: string;
       ProfileFileBase64: string;

}
